export default __webpack_public_path__ + "sounds/framework/10short_success_R.e59143dc.mp3?e59143dc";